module.exports = __webpack_public_path__ + "img/AMWET2.61f72cd7.webp";